// extracted by mini-css-extract-plugin
export var globalGradient = "layout-module--global-gradient--253b6";
export var layout = "layout-module--layout--df830";
export var noGradient = "layout-module--no-gradient--43798";
export var screenContent = "layout-module--screen-content--7e4da";